<template>
  <v-row class="mx-2 pa-0" v-bind:class="verticalMargin ? 'my-4' : 'my-0'">
    <v-col
      v-if="hasCircularProgress"
      class="ma-0 pa-0"
      :cols="$vuetify.breakpoint.xsOnly ? 2 : 1"
    >
      <v-progress-circular
        @click="stepperModel = true"
        :rotate="-90"
        :size="40"
        :width="3"
        :value="stepperProgress"
        color="primary"
        class="vetalfa-pointer"
      >
        <p class="ma-0 pa-0 drugs-header-circular-progress">
          {{ stepperText }}
        </p>
      </v-progress-circular>
    </v-col>
    <v-col :cols="hasCircularProgress ? 10 : 12" class="ma-0 pa-0">
      <v-row class="ma-0 pa-0">
        <p
          v-bind:class="
            isDrugsMode
              ? 'drugs-header-name ma-0'
              : 'drugs-header-name-product ma-0'
          "
          v-html="name"
        ></p>
      </v-row>
      <v-row class="ma-0 pa-0">
        <v-col class="ma-0 pa-0" cols="6">
          <p class="drugs-header-description ma-0">{{ description }}</p>
        </v-col>
        <v-col class="ma-0 pa-0 pt-2" cols="6">
          <v-row align="center" justify="end" class="pa-0 ma-0 pr-2">
            <div v-if="!!references && !!references.length" class="mr-3">
              <v-card
                @click="setClickedReferences(references)"
                elevation="2"
                height="28px"
                style="width: 28px"
                class="pa-0 ma-0"
              >
                <v-row
                  align="center"
                  justify="center"
                  class="pa-0 ma-0"
                  style="height: 100%; width: 100%"
                >
                  <v-icon color="primary">{{
                    mdiInformationOutline
                  }}</v-icon>
                </v-row>
              </v-card>
            </div>
            <!-- <vetalfa-drugs-interactions-button
              class="mr-3"
              v-if="
                displayInteractions &&
                !hasCircularProgress &&
                !!category &&
                category.id === 1
              "
            ></vetalfa-drugs-interactions-button> -->
            <vetalfa-calculator-button
              v-if="displayCalculator && !hasCircularProgress"
            ></vetalfa-calculator-button>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col :cols="2" class="ma-0 pa-0"> </v-col>
    <v-dialog
      v-model="stepperModel"
      transition="dialog-bottom-transition"
      v-bind:content-class="
        $vuetify.breakpoint.xsOnly
          ? 'v-bottom-sheet drugs-header-bottom-sheet'
          : 'drugs-header-bottom-sheet'
      "
    >
      <v-sheet class="text-center">
        <v-row aling="center" justify="start" class="pa-0 ma-0">
          <v-btn
            @click="stepperModel = false"
            text
            class="text-none primary--text"
            >{{ labels.CLOSE }}</v-btn
          >
        </v-row>
        <v-row justify="start" class="ma-0 pa-0">
          <v-stepper v-model="getStepper" vertical>
            <div v-for="(data, index) in getStepperData" :key="data.title">
              <v-stepper-step class="ma-0 py-2 px-5" :step="`${index + 1}`">
                {{ data.title }}
                <small v-if="data.text">{{ data.text }}</small>
              </v-stepper-step>
              <v-divider
                v-if="index + 1 != getStepperData.length"
                vertical
                style="height: 20px; position: relative; left: -37%"
              ></v-divider>
            </div>
          </v-stepper>
        </v-row>
      </v-sheet>
    </v-dialog>
  </v-row>
</template>

<style>
.drugs-header-name {
  color: #393a3a;
  font-size: 26px;
  letter-spacing: 0;
  line-height: 29px;
  word-break: break-word;
}
.drugs-header-description {
  opacity: 0.5;
  color: #393a3a;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 13px;
}
.drugs-header-circular-progress {
  color: #393a3a;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 13px;
}
.drugs-header-name-product {
  color: #004662;
  font-size: 24px;
  font-style: italic;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 29px;
  word-break: break-word;
}
.drugs-header-bottom-sheet {
  max-width: 500px;
}
</style>

<script>
import labels from "@/constants/labels.js";
import { mapGetters, mapMutations } from "vuex";

import { mdiInformationOutline } from "@mdi/js";
import DrugsInteractionButton from "@/components/DrugsInteractionsButton.vue";
export default {
  name: "DrugsHeader",
  components: {
    "vetalfa-drugs-interactions-button": DrugsInteractionButton,
  },
  computed: {
    ...mapGetters("general", [
      "getStepper",
      "getStepperTotal",
      "getStepperModel",
      "getStepperData",
    ]),
    ...mapGetters("drugs", ["category"]),
    stepperProgress() {
      return (100 * this.getStepper) / this.getStepperTotal;
    },
    stepperText() {
      return `${this.getStepper}/${this.getStepperTotal}`;
    },
    stepperModel: {
      get() {
        return (
          this.hasCircularProgress &&
          this.getStepperModel &&
          this.getStepperData &&
          this.getStepperData.length
        );
      },
      set(val) {
        this.setStepperModel(val);
      },
    },
  },
  watch: {},
  props: {
    name: { type: String, required: true, default: "" },
    description: { type: String, required: false, default: "" },
    isDrugsMode: { type: Boolean, required: false, default: true },
    isDrugsManagement: { type: Boolean, required: false, default: true },
    displayCalculator: { type: Boolean, required: false, default: true },
    displayInteractions: { type: Boolean, required: false, default: false },
    verticalMargin: { type: Boolean, required: false, default: true },
    hasCircularProgress: { type: Boolean, required: false, default: false },
    references: { type: Array, required: false, default: null },
  },
  methods: {
    ...mapMutations("general", ["setStepperModel"]),
    ...mapMutations("topics", ["setClickedReferences"]),
  },
  data() {
    return {
      labels,
      prevScrollpos: 0,
      currentScrollPos: 0,
      mdiInformationOutline,
    };
  },
  mounted() {},
  created() {
    this.setStepperModel(true);
  },
};
</script>